<template lang="pug">
Hyperlink(
  :text="label",
  :clickHandler="() => handleScroll()",
  v-if="type === 'hyperlink'",
  :small="small",
  :color="color"
)
TextButton(
  plain,
  :label="label",
  :color="color",
  @click="() => handleScroll()",
  v-else,
  :variant="small ? 'small' : 'large'"
)
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import TextButton from "./TextButton.vue"
import Hyperlink from "./Hyperlink.vue"

export default Vue.extend({
  name: "SamePageLink",
  components: {
    TextButton,
    Hyperlink,
  },
  props: {
    type: {
      type: String,
      default: "text-button",
      validator: (val: string) => ["text-button", "hyperlink"].includes(val),
    },
    small: { type: Boolean, default: false },
    label: { type: String, required: true },
    target: { type: String, required: true },
    color: { type: String, default: "primary" },
    callback: { type: Function as PropType<() => void> },
    default: () => {},
  },
  methods: {
    handleScroll() {
      if (!document.querySelector(this.target)) {
        console.error(
          `Broken reference in component SamePageLink: scroll target "${this.target}" was not found on page!`
        )
        return
      }

      this.$vuetify.goTo(this.target, this.options)
      if (this.callback) this.callback()
    },
  },
  computed: {
    options(): object {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      }
    },
  },
})
</script>
